import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/useIsMobile';
import { formatWeekdayShortDate, getRelativeDayKey } from '@/utils/date';
import { capitalize } from '@/utils/text';

interface Props {
  date: string;
}

export const HomeworkDateHeader: React.FC<Props> = ({ date }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const relativeDayKey = getRelativeDayKey(new Date(date));
  const relativeDay =
    isMobile && relativeDayKey ? `${capitalize(t(relativeDayKey))}, ` : '';

  return (
    <h3 className="text-subhead-14 text-subtle-foreground md:text-callout-16 md:text-foreground">
      {relativeDay}
      {formatWeekdayShortDate(date)}
    </h3>
  );
};
